import { withLazy } from '@/shared/HOC/with-lazy';

export const RedirectLazy = withLazy(() => import('./Redirect'), 'Redirect', '');
